export default "__VITE_ASSET__KBRncYnK__"